import React from 'react';

const markup = String.raw`<div class="card">
<div class="card-head"><p class="card-title" id="vendPOTitle">My purchase orders</p><span class="card-tag" id="vendPOCount">8 shown</span></div>
<table><thead><tr><th>PO number</th><th>Item</th><th>Quantity</th><th>Expected delivery</th><th>Status</th><th>Action</th></tr></thead>
<tbody id="vendPOBody"></tbody></table>
</div>`;

export default function PurchaseOrdersCard() {
  return <div className="raw-fragment" dangerouslySetInnerHTML={{ __html: markup }} />;
}
